import { ReactNode } from 'react';
import { AuthTabs } from './AuthTabs';

interface AuthCardProps {
  children: ReactNode;
  title: string;
  subtitle?: string;
  showTabs?: boolean;
}

/**
 * AuthCard Component - Card container para formulários de autenticação
 *
 * @example
 * ```tsx
 * <AuthCard title="Criar conta" subtitle="Comece sua jornada com a TAIS">
 *   <form>...</form>
 * </AuthCard>
 * ```
 */
export const AuthCard = ({ children, title, subtitle, showTabs = true }: AuthCardProps) => {
  return (
    <div className="w-full max-w-[700px] bg-[#2a2a2a] rounded-[24px] p-12 animate-fadeIn shadow-[0_20px_60px_rgba(0,0,0,0.5)]">
      {/* AuthTabs centralizado - apenas em login/cadastro */}
      {showTabs && (
        <div className="flex justify-center mb-8">
          <AuthTabs />
        </div>
      )}

      <div className="mb-6">
        {/* Título - usando div para evitar CSS global de h2 */}
        <div className="font-bold text-[#F4CC04] mb-2 text-[24px] leading-tight">
          {title}
        </div>
        {subtitle && (
          <div className="text-[#CCCCCC] text-[16px] leading-normal">
            {subtitle}
          </div>
        )}
      </div>
      {children}
    </div>
  );
};
